<template>
  <button class="vet-notes-toggle" @click="toggleVetNotes" v-bind="$attrs">
    <slot>
      <i class="glyphicon glyphicon-list-alt"></i>
      {{ showVetNotes ? 'Hide' : 'Show' }} vet notes
    </slot>
  </button>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'VetNotesToggle',
  methods: {
    ...mapMutations('currentConsult', ['toggleVetNotes']),
  },
  computed: {
    ...mapState('currentConsult', ['showVetNotes']),
  },
}
</script>
